import { render, staticRenderFns } from "./PayersPropertyForm.vue?vue&type=template&id=62a8818b&scoped=true"
import script from "./PayersPropertyForm.vue?vue&type=script&lang=js"
export * from "./PayersPropertyForm.vue?vue&type=script&lang=js"
import style0 from "./PayersPropertyForm.vue?vue&type=style&index=0&id=62a8818b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a8818b",
  null
  
)

export default component.exports